export class Carousels {
    init()
    {
        var carouselThumbs = $('.gallery-thumbs .owl-carousel, .article-list__slider .owl-carousel, .slider .owl-carousel'),
            carouselZoom = $('.gallery-category--zoom-slider .owl-carousel'),
            pluginFlag = carouselThumbs.length || carouselZoom.length;

        if (pluginFlag)
            if (carouselThumbs)
                this.carouselThumbs(carouselThumbs);
        if (carouselZoom)
            this.carouselZoom(carouselZoom);


        var swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 5,
            mousewheel: true,
            direction: 'vertical',
            // loop: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            speed: 500,
            breakpoints: {
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                768: {
                    slidesPerView: 'auto',
                }
            }
        });

        $('#card-1').click(function() {
            $('.gallery.design').addClass('under').removeClass('above');
            $('.gallery.soul-red').addClass('above').removeClass('under');
        });
        $('#card-0').click(function() {
            $('.gallery.design').addClass('above').removeClass('under');      
            $('.gallery.soul-red').addClass('under').removeClass('above');
        });
    }

    carouselThumbs(carousel)
    {
        carousel.owlCarousel({
            items: 1,
            loop: true,
            margin: 0,
            nav: true,
            navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
            dots: false,
            thumbs: true,
            autoplay: typeof carousel.data('autoplay') !== 'undefined' ? carousel.data('autoplay') : false,
            thumbsPrerendered: true,
            onChanged: function (e)
            {
                var itemsLength = this._items.length;

                var $slider = this.$element.closest('.slider'),
                    $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                    $thumbsContainer = $slider.find('.slider-thumbs'),
                    $thumbsList = $slider.find('.owl-thumbs');

                var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                    thumbsListWidth = thumbWidth * itemsLength,
                    thumbsContainerWidth = $thumbsContainer.width();

                var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                    thumbsPositionPart = thumbsOuterWidth / itemsLength;

                var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                    currentSlide = $slides.eq( currentPosition );

                var firstMarginLeft = parseInt( $thumbsList.find('.owl-thumb-item').first().css('margin-left') ),
                    lastMarginRight = parseInt( $thumbsList.find('.owl-thumb-item').last().css('margin-right') );

                var offset = currentPosition === 0
                                    ? -firstMarginLeft
                                    : (currentPosition === itemsLength - 1
                                        ? ( thumbsContainerWidth - thumbsListWidth + lastMarginRight )
                                        : ((-currentPosition + 1) * thumbsPositionPart - firstMarginLeft)
                                    );


                if( thumbsOuterWidth <= 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                        'transform': 'translateX(' + -firstMarginLeft + 'px)'
                    });
                }
                else if( thumbsOuterWidth > 0 )
                {
                    $thumbsList.css({
                        '-webkit-transform': 'translateX(' + offset + 'px)',
                        '-mox-transform': 'translateX(' + offset + 'px)',
                        'transform': 'translateX(' + offset + 'px)'
                    });
                }

                setTimeout(function () {
                    currentSlide.addClass('active');
                });
            }
        });
    }

    carouselZoom(carousel)
    {
        carousel.owlCarousel({
            stagePadding: 40,
            loop: true,
            autoWidth: false,
            center: true,
            margin: 0,
            responsive: {
                0: {
                    items: 3,
                    autoWidth: true
                },
                320: {
                    items: 3
                },
                641: {
                    items: 3,
                    autoWidth: true,
                    center: false
                },
                1024: {
                    items: 4,
                    center: true,
                    autoWidth: true
                },
                1350: {
                    items: 7,
                    center: true,
                    autoWidth: true
                }
            }
        });


        carousel.find('.owl-item').on('click', function ()
        {
            var $this = $(this),
                    index = $this.index(),
                    itemsLength = $this.siblings('.owl-item').length,
                    itemsHandler = $this.closest('.owl-stage-outer'),
                    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

            if ($this.hasClass('zoomed'))
            {
                $this.removeClass('zoomed');
            } else if (($this.prev().hasClass('active') && $this.next().hasClass('active')) || (!$this.prev().hasClass('active') && !$this.next().hasClass('active')))
            {
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            } else if ($this.prev().hasClass('active') && !$this.next().hasClass('active'))
            {
                carousel.trigger('next.owl.carousel', [500]);
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            } else if (!$this.prev().hasClass('active') && $this.next().hasClass('active'))
            {
                carousel.trigger('prev.owl.carousel', [500]);
                $('.zoomed').removeClass('zoomed');
                $this.addClass('zoomed');
            }
        });
    }
}